import React from 'react';

import { Popover } from '@mui/material';

import FilterButton from 'containers/Tasks/components/FilterButton';
import { RiskActionType } from 'utils/api/modules/risks';

import { StyledCheckIcon, StyledTypeOption } from './styles';

export type RiskActionTypeFilterValue = 'all' | RiskActionType;

const TYPE_OPTIONS: { value: RiskActionTypeFilterValue; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: RiskActionType.ControlAction, label: 'Control action' },
];

const RiskActionTypePicker: React.FunctionComponent<{
  value: RiskActionTypeFilterValue;
  onChange: (value: RiskActionTypeFilterValue) => void;
}> = ({ value, onChange }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const label = TYPE_OPTIONS.find((option) => option.value === value)?.label ?? 'All';

  const handleSelect = (next: RiskActionTypeFilterValue): void => {
    onChange(next);
    setAnchorEl(null);
  };

  return (
    <>
      <FilterButton
        prefix="Type"
        value={label}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        isOpen={open}
        testId="risk-actions-type-filter"
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        {TYPE_OPTIONS.map((option) => (
          <StyledTypeOption key={option.value} onClick={() => handleSelect(option.value)}>
            {option.label}
            {value === option.value && <StyledCheckIcon fontSize="small" />}
          </StyledTypeOption>
        ))}
      </Popover>
    </>
  );
};

export default RiskActionTypePicker;
